export const colorPalette = [
  '#0074D9', // Bright Blue
  '#2ECC40', // Green
  '#E74C3C', // Red
  '#9B59B6', // Purple
  '#F1C40F', // Yellow
  '#AAAAAA', // Light Gray
];

export const SalesOrderColorPickerConfig = {
  colorPalette,
};
